var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"sidebar-bar-item",class:{ active: _vm.active }},_vm.$listeners),[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }